import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { GUsersService } from 'src/app/core/http/gUsers/g-users.service';
import { Role, GRolesService } from 'src/app/core/http/gRoles/g-roles.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-adm-group-users',
  templateUrl: './adm-group-users.component.html',
  styleUrls: ['./adm-group-users.component.css']
})
export class AdmGroupUsersComponent implements OnInit {

  constructor(private guserService: GUsersService, private grolesService: GRolesService) { }
  dataSource;
  roles: Role[];
  mailUser = new FormControl();
  ngOnInit(): void {
    this.getUsers();
    this.getGroupRoles();
  }
  displayedColumns: string[] = ['index', 'username', 'email', 'role', 'delete'];
  

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getUsers() {
    this.guserService.GetGroupUsers()
    .subscribe((resp:any) => {
      this.dataSource = new MatTableDataSource(resp);
    })
  }
  deleteUser(id, i) {
    this.guserService.DeleteUserFromGroup(id)
    .subscribe(()=> {
      if (i !== -1) {
        this.dataSource.data.splice(i, 1);
        this.dataSource._updateChangeSubscription();
      } 
    })
  }
  getGroupRoles() {
    this.grolesService.GetGroupRoles()
    .subscribe( resp => {
        this.roles=resp;
      }
    )
  }
  changeRole(userId, roleId) {
    this.grolesService.ChangeGroupRole(userId, roleId)
    .subscribe();
  }
  addUser() {
    var formData = new FormData();
    formData.append('email', this.mailUser.value);
    this.guserService.AddGroupUser(formData)
    .subscribe(resp=> {
      this.dataSource.data.push(resp);
      this.dataSource._updateChangeSubscription();
      this.mailUser.reset();
    })
  }

}
